import script from "./CheckBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckBox.vue?vue&type=script&setup=true&lang=ts"

import "./CheckBox.vue?vue&type=style&index=0&id=801909c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-801909c0"]])

export default __exports__